










































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

import QueryForm from '@/components/QueryForm.vue'
import QueryCondition from '@/model/QueryCondition'

import { Api } from '@/service/api'

const LMS_MANAGER_HOST = process.env.VUE_APP_LMS_MANAGER_HOST

@Component({
  components: {
    QueryForm
  }
})
export default class Lms extends Vue {

  private data: any = null
  private student_ids = ''
  private current_order_sn = ''
  private current_course_ids = ''
  private form: any = null
  private queryConditions: Array<QueryCondition> = []
  private hideDeleteCourse = false
  private sort_by = ''

  private created () {
    // this.queryConditions.push(new QueryCondition('手机号', 'phone', 'input'))
    // this.queryConditions.push(new QueryCondition('学生id', 'student_ids', 'input'))
    // this.queryConditions.push(new QueryCondition('订单号', 'order_sn', 'input'))
    // this.queryConditions.push(new QueryCondition('订单日期', 'pay_time', 'date_range'))
    // this.queryConditions.push(new QueryCondition('状态', 'status', 'select', [
    //   new SelectOption('aaa', 'bbb'),
    //   new SelectOption('111', '222'),
    // ]))
  }

  private mounted () {
    this.getNextStudent()

    document.addEventListener('keydown', this.handleKeyDown)
  }

  private handleKeyDown (e: any) {
    if (e.key === 'F2') {
      this.getNextStudent()
    }
  }

  // 获取待确认的数据
  private async getWaitConfirmData () {
    await Api.getWaitConfirmData()
    this.getNextStudent()
  }

  private query (conditions: Map<string, string>) {
    console.info(conditions)
  }

  private async getNextStudent () {
    const res: any = await Api.getNextStudent()
    this.student_ids = res.data
    await this.getStudentOrder()
  }

  private async getStudentOrder () {
    const order_res: any = await Api.getStudentOrder(this.student_ids)
    this.data = order_res.data
    console.info(this.data)
    this.current_course_ids = ''
  }

  get filterData () {
    let result = null
    if (this.hideDeleteCourse) {
      result = this.data.course_students.filter((x: any) => !x.is_deleted)
    } else {
      result = this.data.course_students.map((x: any) => x)
    }

    if (this.sort_by) {
      result.sort((x1: any, x2: any) => x1[this.sort_by] > x2[this.sort_by] ? 1 : -1)
    }

    return result
  }

  private sortBy (col: string) {
    this.sort_by = col
  }

  private setCurrentOrder (order_sn: string) {
    this.current_order_sn = order_sn
  }

  private setCurrentCourseIds (course_ids: string) {
    this.current_course_ids = course_ids
  }

  private phoneLink (phone: string) {
    return LMS_MANAGER_HOST + '/orders/order-list?orderBy=&source_order_sn=&orderByDirection=&product_name=&pageNum=1&refund_status=&product_type=&created_time=&source=&payment_time=&payment_method=&recipient_name=&recipient_phone=&source_pay_id=&user_name=&user_phone=' + phone + '&group_id=&teacher_name='
  }

  private orderLink (row: any) {
    return LMS_MANAGER_HOST + '/orders/order-super-detail?order_id=' + row.order_id
  }

  private studentLink (studentId: number) {
    return LMS_MANAGER_HOST + '/lesson/student-lesson/' + studentId
  }

  private studentDetailLink (studentId: number) {
    return LMS_MANAGER_HOST + '/student/student-detail/' + studentId
  }

  private currentOrder (value: string) {
    if (!value || !this.current_order_sn) {
      return
    }

    if (value.indexOf(this.current_order_sn) >= 0) {
      return 'current-order'
    }
  }

  private currentCourseId (value: string) {
    if (!value || !this.current_course_ids) {
      return
    }

    if (this.current_course_ids.indexOf(value) >= 0) {
      return 'current-course-id'
    }
  }

  private courseLink (courseId: number) {
    return LMS_MANAGER_HOST + '/lesson/lesson-list/' + courseId
  }

  private orderValid (order: any) {
    if (order.status === 'close' || order.is_prepayment === 1) {
      return false
    }
    return true
  }

  private course_ids_changed (row: any) {
    let course_ids = row.course_ids
    let lesson_count = 0
    if (course_ids) {
      course_ids = course_ids.replace('，', ',').split(',')
      for (const index in course_ids) {
        const course_id = course_ids[index]
        for (const csIndex in this.data.course_students) {
          const courseStudent = this.data.course_students[csIndex]
          if (courseStudent.course_id * 1 === course_id * 1) {
            const has_lesson_count = courseStudent.has_lesson_count
            if (has_lesson_count * 1 > 0) {
              lesson_count = lesson_count + has_lesson_count
            }
            break
          }
        }
      }
    }
    this.$nextTick(() => {
      row.has_lesson_count = lesson_count
      if (!row.lesson_count) {
        row.lesson_count = lesson_count
      }
      this.$forceUpdate()
    })
  }

  private async saveOrders () {
    const putData = {
      rows: [] as any
    }

    for (let i = 0; i < this.data.orders.length; i++) {
      const order = this.data.orders[i]
      if (this.orderValid(order)) {

        const course_ids = order.course_ids.replace('，', ',').replace(' ', '')
        const lesson_count = order.lesson_count * 1
        const memo = order.memo
        const status = order.status

        if (!course_ids && !lesson_count && !memo) {
          continue
        }

        if (isNaN(lesson_count)) {
          this.$message.error('课程总节数不能为空')
          return
        }

        const row = {
          id: order.da_order_confirm_income_id,
          memo: memo,
          course_ids: course_ids,
          lesson_count: lesson_count,
          status: status
        }
        putData.rows.push(row)
      }
    }

    if (putData.rows.length === 0) {
      // this.$message.info('无数据需保存')
      return true
    }

    const res: any = await Api.updateStudentOrder(putData)
    return res.code === 0

  }

  private async confirm () {
    const res: any = await Api.keyUserConfirm(this.student_ids)
    return res.code === 0
  }

  private async waitConfirm () {
    const res: any = await Api.keyUserWaitConfirm(this.student_ids)
    return res.code === 0
  }

  private async updateStudentOrders () {

    if (await this.saveOrders()) {
      this.$message.info('保存成功')
    }
  }

  private async updateStudentOrdersAndConfirm () {

    if (await this.saveOrders()) {
      const result = await this.confirm()
      if (result) {
        this.$message.info('保存并确认成功')
      }
    }
  }

  private async updateStudentOrdersAndWaitConfirm () {

    if (await this.saveOrders()) {
      const result = await this.waitConfirm()
      if (result) {
        this.$message.info('保存待确认成功')
      }
    }
  }

  private onShowHideDeleteCourse (e: any) {
    this.hideDeleteCourse = e.target.checked
  }
}
